import React, { useCallback, useState } from 'react'
import { Alert } from 'react-bootstrap'
import Progress from './Progress'
import { ButtonWithLoadingState } from '../../../Buttons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useArticleDataState } from '../../../../stores/Configuration/ArticleDataProvider'
import { useArticlesState } from '../../../../stores/Configuration/ArticlesProvider'
import ModalComponent2 from '../../../Modals/ModalComponent2'

const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`

const Sidebar = () => {
  const {
    submitCopyArticle,
    errorsOccurredOnSubmit,
    setSuccessSubmit,
    successSubmit,
    sizeSystems,
  } = useArticleDataState()
  const { setFilterArticle } = useArticlesState()
  const [isSaving, setIsSaving] = useState(false)
  const [openInfoModal, setOpenInfoModal] = useState(false)
  const navigate = useNavigate()

  const handleSubmitClick = useCallback(
    async (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (
        sizeSystems.length > 1 &&
        !sizeSystems.some((system) => system.isSelected)
      ) {
        setOpenInfoModal(true)
        return true
      }

      setSuccessSubmit(false)
      setIsSaving(true)
      const createdInfo = await submitCopyArticle()
      if (createdInfo) {
        const { articleId, number } = createdInfo
        setFilterArticle(number)
        setTimeout(() => {
          navigate(`/articlesAdministration/editArticle/${articleId}`)
        }, 1500)
      }

      setIsSaving(false)
    },
    [
      setSuccessSubmit,
      submitCopyArticle,
      setFilterArticle,
      sizeSystems,
      navigate,
    ]
  )

  const { t } = useTranslation()

  return (
    <StyledContainer>
      <header>
        <div className='h2'>
          {t('articleAdminOverlayProgress:headerCreate')}
        </div>
      </header>
      <div className='content'>
        <ButtonWithLoadingState
          className='submit-btn mb-3'
          isLoading={isSaving}
          onClick={handleSubmitClick}
          disabled={isSaving || successSubmit}
          buttonText={t('articleAdminOverlayProgress:save')}
          loadingText={t('articleAdminOverlayProgress:save')}
        />
        {!!errorsOccurredOnSubmit && (
          <Alert variant='danger'>
            {t('articleAdminOverlayProgress:danger')}
          </Alert>
        )}
        {!!successSubmit && (
          <Alert variant='success'>
            {t('articleAdminOverlayProgress:success')}
          </Alert>
        )}
        {<Progress />}
      </div>
      {openInfoModal && (
        <ModalComponent2
          ModalTitle={t('articleAdminOverlayProgress:selectSizeSystem')}
          BodyPart1={t('articleAdminOverlayProgress:selectSizeSystemBody')}
          button1Function={() => setOpenInfoModal(false)}
          button1Text={t('okButton')}
          withoutCloseButton={true}
          functionCancel={() => {
            setOpenInfoModal(false)
          }}
        />
      )}
    </StyledContainer>
  )
}

export default Sidebar
